<!--
 * @Author       : panyangyang
 * @Date         : 2026-09-01 11:06:14
 * @LastEditTime : 2026-09-01 13:39:24
 * @LastEditors  : panyangyang
 * @Description  : 数字滚动效果
 * @FilePath     : \ngs_platform_manage_admin\src\views\large-screen\components\DigitRoll.vue
-->
<template>
	<div class="roll-box">
		<div :class="'roll-list-' + index">
			<div v-for="num in numbers" :key="num" class="roll-number">
				{{ num }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DigitRoll',

	props: {
		value: {
			type: Number,
			default: 0
		},
		index: {
			type: Number,
			default: 0
		}
	},

	data() {
		return {
			current: this.value,
			numbers: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
		}
	},

	mounted() {
		setTimeout(() => {
			const el = document.getElementsByClassName('roll-list-' + this.index)[0]
			el.style.transform = `translateY(-${this.current * 60}px)`
			el.style.transition = 'transform 3s'
		}, 100)
	},

	watch: {
		value(value) {
			this.current = value
		}
	}
}
</script>

<style scoped>
.roll-box {
	width: 40px;
	height: 60px;
	text-align: center;
	overflow: hidden;
}

.roll-number {
	width: 40px;
	height: 60px;

	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
